import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AccordionModule, AccordionService, ButtonModule, HrModule, SvgIconModule } from '@hdms/shared/ui-core';
import { RouterLinkModule } from '@hdms/shared/util-core';

import { LinksColumnAccordionComponent } from './links-column-accordion.component';
import { LinksColumnWrapperComponent } from './links-column-wrapper.component';

@NgModule({
  declarations: [LinksColumnAccordionComponent, LinksColumnWrapperComponent],
  imports: [CommonModule, ButtonModule, SvgIconModule, RouterLinkModule, HrModule, AccordionModule],
  providers: [AccordionService],
  exports: [LinksColumnAccordionComponent, LinksColumnWrapperComponent]
})
export class LinksColumnModule {}
